import { render, staticRenderFns } from "./userTimeline.vue?vue&type=template&id=201aa1da&scoped=true&"
import script from "./userTimeline.vue?vue&type=script&lang=js&"
export * from "./userTimeline.vue?vue&type=script&lang=js&"
import style0 from "./userTimeline.vue?vue&type=style&index=0&id=201aa1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201aa1da",
  null
  
)

export default component.exports